import React from "react";
import { FormattedMessage } from "react-intl";
import { formatPhoneNumber } from "~/common/utils";
import { TUser } from "~/types/user";

export function ManagerInfo(managerObject: { manager: TUser["manager"] }) {
  let userManager = managerObject.manager;

  const handlePhoneClick = () => {
    if (userManager?.phone) {
      window.open(`tel:${userManager.phone}`, '_self');
    }
  };

  return (
    <div className="tw-mt-6 tw-w-full tw-pb-4">
      <div className="tw-overflow-hidden tw-rounded-md">
        <div className="tw-relative tw-flex tw-items-center tw-bg-[#f2f6f9] tw-py-2">
          <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-[3px] tw-bg-[#5C9ACF]" />
          <h4 className="tw-pl-[18px] tw-text-sm tw-font-medium tw-text-[#5b9bd1]">
            <FormattedMessage id="manager_info.your_manager" />
          </h4>
        </div>

        <div className="tw-flex tw-flex-col tw-items-start tw-bg-white tw-px-4 tw-py-3">
          <div className="tw-mb-3 tw-pl-3 tw-text-sm tw-font-medium tw-text-gray-900">
            {userManager && userManager.last_name && userManager.first_name ? (
              `${userManager.last_name} ${userManager.first_name}`
            ) : (
              <FormattedMessage id="None" />
            )}
          </div>

          <div 
            onClick={handlePhoneClick}
            className={`tw-flex tw-items-center tw-justify-start tw-gap-1.5 tw-pl-2.5 ${
              userManager?.phone 
                ? 'tw-cursor-pointer hover:tw-opacity-80 tw-transition-opacity' 
                : 'tw-cursor-default'
            }`}
          >
            <div className="tw-m-0 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-p-0">
              <PhoneIcon className="tw-m-0 tw-h-full tw-w-full tw-p-0" />
            </div>
            <span className="tw-m-0 tw-text-sm tw-leading-[1.2] tw-text-gray-700 tw-no-underline">
              {userManager && userManager.phone ? (
                formatPhoneNumber(userManager.phone)
              ) : (
                <FormattedMessage id="None" />
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export const PhoneIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 71.31 122.88"
    className={`tw-text-[#5b9bd1] dark:tw-text-white ${className}`}
    aria-hidden="true"
    focusable="false"
  >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        d="M12.47,0h46.36c3.43,0,6.55,1.4,8.81,3.66c2.26,2.26,3.66,5.38,3.66,8.81v97.94c0,3.43-1.4,6.55-3.66,8.81 c-2.26,2.26-5.38,3.66-8.81,3.66H12.47c-3.43,0-6.55-1.4-8.81-3.66C1.4,116.96,0,113.84,0,110.41V12.47c0-3.43,1.4-6.55,3.66-8.81 C5.92,1.4,9.04,0,12.47,0L12.47,0z M28.93,113c-0.83,0-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5h13.72c0.83,0,1.5,0.67,1.5,1.5 c0,0.83-0.67,1.5-1.5,1.5H28.93L28.93,113z M27.65,7.16c1.31,0,2.38,1.07,2.38,2.38c0,1.31-1.07,2.38-2.38,2.38 c-1.31,0-2.38-1.07-2.38-2.38C25.27,8.23,26.34,7.16,27.65,7.16L27.65,7.16z M35.65,7.16c1.31,0,2.38,1.07,2.38,2.38 c0,1.31-1.07,2.38-2.38,2.38c-1.32,0-2.38-1.07-2.38-2.38C33.27,8.23,34.34,7.16,35.65,7.16L35.65,7.16z M43.65,7.16 c1.31,0,2.38,1.07,2.38,2.38c0,1.31-1.07,2.38-2.38,2.38c-1.32,0-2.38-1.07-2.38-2.38C41.27,8.23,42.34,7.16,43.65,7.16L43.65,7.16 z M3,99.29h65.31V19.21H3V99.29L3,99.29z M68.31,102.29H3v8.12c0,2.6,1.07,4.97,2.78,6.69c1.72,1.72,4.09,2.78,6.69,2.78h46.36 c2.6,0,4.97-1.07,6.69-2.78c1.72-1.72,2.78-4.09,2.78-6.69V102.29L68.31,102.29z M3,16.21h65.31v-3.74c0-2.6-1.07-4.97-2.78-6.69 C63.81,4.06,61.44,3,58.83,3H12.47C9.87,3,7.5,4.06,5.78,5.78C4.06,7.5,3,9.87,3,12.47V16.21L3,16.21z"
      />
  </svg>
);
